import { api } from '../api'

import type {
  WorkSchedule,
  WorkSchedulePayload,
  WorkingBreak,
  WorkingBreakPayload,
  WorkingBreaks
} from './work-schedules-services-types'

export const workSchedulesServices = {
  get: async () => {
    const { data } = await api.get<WorkSchedule[]>('/work-schedules/')
    return data
  },
  getBreaks: async () => {
    const { data } = await api.get<WorkingBreaks[]>('/work-breaks/')
    return data
  },
  addBreak: async (payload: WorkingBreakPayload) => {
    const { data: data } = await api.post<WorkingBreak>('/work-breaks/', payload)
    return data
  },
  updateBreak: async (id: number, payload: Partial<WorkingBreakPayload>) => {
    const { data: data } = await api.patch<WorkingBreak>(`/work-breaks/${id}/`, payload)
    return data
  },
  deleteBreak: async (id: number) => {
    const { data: data } = await api.delete<WorkingBreak>(`/work-breaks/${id}/`)
    return data
  },
  update: async (id: number, payload: Partial<WorkSchedulePayload>) => {
    const { data: data } = await api.patch<WorkSchedule>(`/work-schedules/${id}/`, payload)
    return data
  }
}
